import { PayoutBranchQueryModeUtil } from './../../../response/internal/list/agentlistresult';
import { ReqPaymentRate } from './../../../model/shared/transaction/payment';
import { TxnSubInfoResponse } from 'app/response/txnsubinforesult';
import { PasswordChange } from './../../../view-model/common/passwordchange';
import { LoginResult } from './../../../response/loginresult';
import { Admin } from './../../../model/admin/admin';
import { BankDepositInfo, ReqDisableDipositList } from './../../../model/shared/bank/bankdepositinfo';
import { ExpiredSearch } from './../../../view-model/admin/expiredmanage';
import {FIUReportListItem, FIUReportDetail} from '../../../model/admin/fiureport/fiureportlistitem';
import {FIUReportSearch} from '../../../model/admin/fiureport/fiureportsearch';
import {FxRate, FxRateList} from '../../../model/admin/fxrate';
import {ServiceCharge, ServiceChargeList} from '../../../model/admin/servicecharge';
import {FxRateHistorySearch} from '../../../model/shared/admin/fxratehistory';
import {User, Agent, Customer, MergeCustomer, UserListQueryMode, UserListQueryModeInstance} from '../../../model/shared/user/user';
import {ADMFxRateHistoryResult} from '../../../response/admin/admfxratehistoryresult';
import {ADMFxRateResult, ADMFxRateHistoryListResult} from '../../../response/admin/admfxrateresult';
import {ADMHomeResult} from '../../../response/admin/admhomeresult';
import {ADMPartnerDetailResult} from '../../../response/admin/admpartnerdetailresult';
import {ADMPartnersResult} from '../../../response/admin/admpartnersresult';
import {ADMReportPartnerDetailResult} from '../../../response/admin/admreportpartnerdetailresult';
import {ADMReportPartnerResult} from '../../../response/admin/admreportpartnerresult';
import {ADMServiceChargeDetailResult} from '../../../response/admin/admservicechargedetailresult';
import {ADMServiceChargeByTypeResult, ADMServiceChargeResult} from '../../../response/admin/admservicechargeresult';
import {ADMTimeResult} from '../../../response/admin/admtimeresult';
import {BaseResponse} from '../../../response/internal/baseresponse';
import {Api} from '../../config/api';
import {RequestService} from '../request.service';
import {SessionService} from '../session.service';
import {UserService} from '../user.service';
import {Injectable} from '@angular/core';
import {RequestOptions} from '@angular/http';
import {Subject, Observable} from 'rxjs/Rx';
import {UserSearch} from '../../../model/shared/user/usersearch';
import {UserListResult, CustomerListResult, ReceiverListResult} from '../../../response/userlistresult';
import {UserRegisterResult} from '../../../response/userregistresult';
import {UserModifyResult, UserValidateMobile, UserVerifyMobile, UserValidateMobileResult} from '../../../response/usermodifyresult';
import {UserStatisticsResult} from '../../../response/userstatisticsresult';
import {UserDetailResult} from '../../../response/userdetailresult';
import {TransactionSearch, TransactionSubInfSearch} from '../../../model/shared/transaction/transactionsearch';
import {TransactionApproveResult} from '../../../response/transactionapproveresult';
import {TransactionPendingResult} from '../../../response/transactionpendingresult';
import {TransactionCancelResult} from '../../../response/transactioncancelresult';
import {TransactionDetailResult} from '../../../response/transactiondetailresult';
import {InbTransactionDetailResult} from '../../../response/transactiondetailresult';
import { TransactionSubInfListResult, TransactionSubInfResult } from '../../../response/transactionlistresult';
import {TransactionListResult} from '../../../response/transactionlistresult';
import {TransactionRateResult} from '../../../response/transactionrateresult';
import {TransactionSaveResult} from '../../../response/transactionsaveresult';
import {TransactionCancel} from '../../../view-model/agent/transactioncancel';
import {TransactionApprove} from '../../../view-model/agent/transactionapprove';
import {TransactionPending} from '../../../view-model/agent/transactionpending';
import {InbTransactionListResult} from '../../../response/transactionlistresult';
import {PayoutCountryListResult} from '../../../response/internal/list/payoutcountrylist';
import {PayoutBranchListResult, PayoutBankListResult, AgentListResult, PayoutBranch, AgentDetailResult, PayoutBranchQueryMode} from '../../../response/internal/list/agentlistresult';
import {Transaction, TransactionDetail, InbTransactionDetail, PayoutAccValidate, TxnDepositInfo, SubInfTransaction} from '../../../model/shared/transaction/transaction';
import {BranchDetailResult, BranchListResult} from '../../../response/branchdetailresult';
import {UserRemittanceResult} from '../../../response/userremittanceresult';
import {DepositHistoryResult, DepositHistoryListSearch} from '../../../response/deposithistoryresult';
import {UserTransactionList} from '../../../model/shared/transaction/transaction';
import {UserTransactionListResult} from '../../../response/usertransactionlistresult';
import {RefundSearch, RefundListResult, RefundDetailResult, Refund} from '../../../model/agent/lianlian/refund';
import {AddressSearchResult} from '../../../response/addressresult';
import {UserKycCountResponse} from '../../../response/userkyccount';
import { TransactionCheckRemittanceResult } from '../../../response/transactioncheckremittanceresult';
import {Notice} from '../../../model/shared/notice/notice';
import {NoticeSearch} from '../../../model/shared/notice/noticesearch';
import {NoticeListResult} from '../../../response/noticelistresult';
import {NoticeDetailResult} from '../../../response/noticedetailresult';
import {NoticeModifyResult} from '../../../response/noticemodifyresult';
import {Push} from '../../../model/shared/notice/push';
import {PushSearch} from '../../../model/shared/notice/pushsearch';
import {PushListResult} from '../../../response/pushlistresult';
import {PushDetailResult} from '../../../response/pushdetailresult';
import {PushModifyResult} from '../../../response/pushmodifyresult';
import { TransactionGetResult } from 'app/response/transactiongetresult';
import {Version} from '../../../model/shared/mobile/version';
import {VersionSearch} from '../../../model/shared/mobile/versionsearch';
import {VersionListResult} from '../../../response/versionlistresult';
import {VersionDetailResult} from '../../../response/versiondetailresult';
import {VersionModifyResult} from '../../../response/versionmodifyresult';
import { LoginHistorySearch } from 'app/model/shared/admin/loginhistorysearch';
import { BankDepositSearch } from '../../../model/shared/bank/depositsearch';
import { BankDepositListMappedTxn, BankDepositListMappedTxnList } from '../../../model/shared/bank/bank-deposit-list-mapped-txn';
import { UpdateCustomerExtName } from '../../../model/shared/bank/update-customer-ext-name';
import { Bankaccountupdatelist } from '../../../model/shared/bank/bankaccountupdatelist';
import { DepositSlipInfo } from '../../../response/depositslipresult';
import { ReqRefundDepositList } from 'app/model/shared/bank/bankdepositinfo';
import { UploadFile } from 'app/model/shared/etc/file';
import { DepositBranchAddForm, DepositBranchList } from 'app/model/shared/bank/depositbranch';
import { BankBranchListResult } from 'app/response/bankbranchresult';
import { ReceiverList, ReceiverListQueryMode, ReqReceiverList } from 'app/response/internal/list/userlist';
import { ManageAccount, ManageAccountForSave, ManageAccountSearch } from 'app/response/manageaccount';
import { PartnerDetailResult } from 'app/response/partnerdetailresult';
import { MailSubscribe } from 'app/model/shared/mail/mailRequest';
import { UpdateMailingInfo } from 'app/admin/mailing/mailing.component';
import { TxnValidResult } from 'app/response/txnvalidresult';
import { PartnerGroupResult } from 'app/response/partnergroupresult';
import { CustomerSnsInfoResult } from 'app/response/customersnsresult';
@Injectable()
export class AdminService {

  _options: RequestOptions;
  _isLogin: Boolean = this.sessionService.getAdminLogin();
  _loginSubscription: Subject<boolean>;
  _adminInfo: User;

  _selectedFIUItem: FIUReportListItem;

  constructor(
    userService: UserService,
    public sessionService: SessionService,
    public requestService: RequestService) {

    this._loginSubscription = this.sessionService.admLoginStatus;
    this._options = new RequestOptions();
    this._options.headers = userService._options.headers;
  }

  sessionInit() {
    this.sessionService.clear();
    this.requestService._raw().get(Api.Common.sessionInit).subscribe();
  }

  time(): Observable<ADMTimeResult> {
    return this.requestService.getBasic(Api.Admin.Time, this._options, ADMTimeResult);
  }

  home(): Observable<ADMHomeResult> {
    return this.requestService.getBasic(Api.Admin.Home, this._options, ADMHomeResult);
  }

  partnerdetail(partner_id: string): Observable<ADMPartnerDetailResult> {
    return this.requestService.getBasic(Api.Admin.PartnerDetail(partner_id), this._options, ADMPartnerDetailResult);
  }

  /*FXRate*/

  fxpartners(): Observable<ADMPartnersResult> {
    return this.requestService.getCacheMode(Api.Admin.FXPartner, this._options, ADMPartnersResult, 10);
  }

  fxpayoutpartners(): Observable<ADMPartnersResult> {
    return this.requestService.getCacheMode(Api.Admin.FXPayoutPartner, this._options, ADMPartnersResult, 10);
  }

  fxcountrydetail(partner_id: string): Observable<ADMFxRateResult> {
    return this.requestService.getBasic(Api.Admin.FXCountryRates(partner_id), this._options, ADMFxRateResult);
  }

  fxpartnerdetail(partner_id: string): Observable<ADMFxRateResult> {
    return this.requestService.getBasic(Api.Admin.FXPartnerRates(partner_id), this._options, ADMFxRateResult);
  }

  fxratecountryupdate(partner_id: string, idx, rate: FxRate): Observable<ADMFxRateResult> {
    return this.requestService.postBasic(Api.Admin.FXCountryUpdate(partner_id, idx), this._options, rate, ADMFxRateResult);
  }

  fxratepartnerupdate(partner_id: string, idx, rate: FxRate): Observable<ADMFxRateResult> {
    return this.requestService.postBasic(Api.Admin.FXPartnerUpdate(partner_id, idx), this._options, rate, ADMFxRateResult);
  }

  fxnewcountry(rate: FxRate): Observable<ADMFxRateResult> {
    return this.requestService.postBasic(Api.Admin.FxNewCountryRate(rate.partner_id), this._options, rate, ADMFxRateResult);
  }

  fxnewpartner(rate: FxRate): Observable<ADMFxRateResult> {
    return this.requestService.postBasic(Api.Admin.FxNewPartnerRate(rate.partner_id), this._options, rate, ADMFxRateResult);
  }

  fxhistoryremitters(): Observable<ADMFxRateHistoryResult> {
    return this.requestService.getCacheMode(Api.Admin.FxHistoryRemitters, this._options, ADMFxRateHistoryResult);
  }

  fxhistorycountries(partner_id: string): Observable<ADMFxRateHistoryResult> {
    return this.requestService.getBasic(Api.Admin.FxHistoryCountries(partner_id), this._options, ADMFxRateHistoryResult);
  }

  fxhistorypartners(partner_id): Observable<ADMFxRateHistoryResult> {
    return this.requestService.getBasic(Api.Admin.FxHistoryPartners(partner_id), this._options, ADMFxRateHistoryResult);
  }

  fxhistory(options: FxRateHistorySearch): Observable<ADMFxRateHistoryListResult> {
    return this.requestService.postBasic(Api.Admin.FxHistory, this._options, options, ADMFxRateHistoryListResult);
  }

  fxdelete(fxrate_idx): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.FxDeleteRate(fxrate_idx), this._options, BaseResponse);
  }

  fxpartnerrate(): Observable<ADMFxRateResult> {
    return this.requestService.getBasic(Api.Admin.FXPartnerRate, this._options, ADMFxRateResult);
  }

  fxratelistcountryupdate(partner_id: string, rate: FxRateList): Observable<ADMFxRateResult> {
    return this.requestService.postBasic(Api.Admin.FXListCountryUpdate(partner_id), this._options, rate, ADMFxRateResult);
  }

  fxratelistpartnerupdate(partner_id: string, rate: FxRateList): Observable<ADMFxRateResult> {
    return this.requestService.postBasic(Api.Admin.FXListPartnerUpdate(partner_id), this._options, rate, ADMFxRateResult);
  }

  /*FXRate End*/

  /*ServiceCharge*/

  checktransactiondetail(detail: InbTransactionDetail): Observable<CustomerListResult> {  // popup창에 띄울 KYC Information get
    return this.requestService.postBasic(Api.Admin.TransactionCheckDetail, this._options, detail, CustomerListResult);
  };

  servicechargepartners(): Observable<ADMPartnersResult> {
    return this.requestService.getCacheMode(Api.Admin.SVCChargePartner, this._options, ADMPartnersResult, 10);
  }

  servicechargepayoutpartners(partner_id?: string): Observable<ADMPartnersResult> {
    let url = Api.Admin.SVCChargePayoutPartner;  // var -> let modified
    if (partner_id) {
      url = url.concat('?except=' + partner_id);
    }
    return this.requestService.getBasic(url, this._options, ADMPartnersResult);
  }

  servicechargecountrydetail(partner_id: string): Observable<ADMServiceChargeResult> {
    return this.requestService.getBasic(Api.Admin.SVCChargeCountryRates(partner_id), this._options, ADMServiceChargeResult);
  }

  servicechargepartnerdetail(partner_id: string): Observable<ADMServiceChargeResult> {
    return this.requestService.getBasic(Api.Admin.SVCChargePartnerRates(partner_id), this._options, ADMServiceChargeResult);
  }

  servicecharge3rdpartydetail(partner_id: string): Observable<ADMServiceChargeResult> {
    return this.requestService.getBasic(Api.Admin.SVCCharge3rdPartyRates(partner_id), this._options, ADMServiceChargeResult);
  }

  // servicechargecountryupdate(partner_id: string, idx, charge: ServiceCharge): Observable<ADMServiceChargeResult> {
  //   return this.requestService.postBasic(Api.Admin.FXCountryUpdate(partner_id, idx), this._options, charge, ADMServiceChargeResult);
  // }

  // servicechargepartnerupdate(partner_id: string, idx, charge: ServiceCharge): Observable<ADMServiceChargeResult> {
  //   return this.requestService.postBasic(Api.Admin.FXPartnerUpdate(partner_id, idx), this._options, charge, ADMServiceChargeResult);
  // }

  // servicecharge3rdpartyupdate(partner_id: string, idx, charge: ServiceCharge): Observable<ADMServiceChargeResult> {
  //   return this.requestService.postBasic(Api.Admin.FXPartnerUpdate(partner_id, idx), this._options, charge, ADMServiceChargeResult);
  // };

  servicechargenewcountry(charge: ServiceCharge): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeNewCountryCharge(charge.partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargenewpartner(charge: ServiceCharge): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeNewPartnerCharge(charge.partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargenew3rdparty(charge: ServiceCharge): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeNew3rdPartyCharge(charge.partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargeupdatecountry(charge: ServiceCharge): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeUpdateCountryCharge(charge.partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargeupdatepartner(charge: ServiceCharge): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeUpdatePartnerCharge(charge.partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargeupdate3rdparty(charge: ServiceCharge): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeUpdate3rdPartyCharge(charge.partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargelistupdatecountry(partner_id: string, charge: ServiceChargeList): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeListUpdateCountryCharge(partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargelistupdatepartner(partner_id: string, charge: ServiceChargeList): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeListUpdatePartnerCharge(partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargelistupdate3rdparty(partner_id: string, charge: ServiceChargeList): Observable<ADMServiceChargeResult> {
    return this.requestService.postBasic(Api.Admin.SVCChargeListUpdate3rdPartyCharge(partner_id), this._options, charge, ADMServiceChargeResult);
  }

  servicechargedetailall(partner_id: string, target_id: string): Observable<ADMServiceChargeByTypeResult> {
    return this.requestService.getBasic(Api.Admin.SVCChargeDetailAll(partner_id, target_id), this._options, ADMServiceChargeByTypeResult);
  }

  // servicechargedetailbytype(partner_id: string, target_id: string, type: string): Observable<ADMServiceChargeResult> {
  //   return this.requestService.get(Api.Admin.SVCChargeDetailByType(partner_id, target_id, type), this._options, ADMServiceChargeResult);
  // }

  servicechargedelete(idx: string): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.SVCChargeDelete(idx), this._options, BaseResponse);
  }


  servicechargedetail(idx: string): Observable<ADMServiceChargeDetailResult> {
    return this.requestService.getBasic(Api.Admin.SVCChargeDetail(idx), this._options, ADMServiceChargeDetailResult);
  }


  /*ServiceCharge End*/

  inbreportdetail(partner_name: string, partner_country: string, from: string, to: string): Observable<ADMReportPartnerDetailResult> {
    return this.requestService.getBasic(Api.Admin.InbReportPartnerDetail(partner_name, partner_country) + '?from=' + from + '&to=' + to, this._options, ADMReportPartnerResult);
  }

  reportpartners(): Observable<ADMReportPartnerResult> {
    return this.requestService.getCacheMode(Api.Admin.ReportPartner, this._options, ADMReportPartnerResult, 10);
  }

  reportdetail(partner_id: string, from: string, to: string): Observable<ADMReportPartnerDetailResult> {
    return this.requestService.getBasic(Api.Admin.ReportPartnerDetail(partner_id) + '?from=' + from + '&to=' + to, this._options, ADMReportPartnerResult);
  }

  reportInbpartners(): Observable<ADMReportPartnerResult> {
    return this.requestService.getCacheMode(Api.Admin.ReportInbPartner, this._options, ADMReportPartnerResult);
  }

  customer(option: UserSearch): Observable<UserListResult> {
    return this.requestService.postBasic(Api.Admin.CustomerList, this._options, option, UserListResult);
  }

  customerdetail(id: string, querymode: UserListQueryMode = UserListQueryMode.Full): Observable<UserDetailResult> {
    return this.requestService.getBasic(Api.Admin.CustomerList + '/' + id + '/detail' + '?query=' + UserListQueryModeInstance.conv(querymode), this._options, UserListResult);
  }

  customerregister(user: User): Observable<UserRegisterResult> {
    return this.requestService.postBasic(Api.Admin.CustomerRegister, this._options, user, UserRegisterResult);
  }

  customerCheck(user: User): Observable<UserRegisterResult> {
    return this.requestService.postBasic(Api.Admin.CustomerCheck, this._options, user, UserRegisterResult);
  }

  customermodify(user: User): Observable<UserModifyResult> {
    return this.requestService.postBasic(Api.Admin.CustomerModify, this._options, user, UserModifyResult);
  }

  customermodifyvalid(user: User): Observable<UserModifyResult> {
    return this.requestService.postBasic(Api.Admin.CustomerModifyValid, this._options, user, UserModifyResult);
  }

  customerstatistics(id: string, year, type: string): Observable<UserStatisticsResult> {
    return this.requestService.getBasic(Api.Admin.CustomerStatistics(id, year, type), this._options, UserStatisticsResult);
  }

  // customeraccountregistration(): Observable<BaseResponse> {
  //   return this.requestService.getCacheMode(Api.Admin.CustomerAccountRegistration, this._options, BaseResponse);
  // }
  // customeraccountvalidation(account: AccountValidation): Observable<BaseResponse> {
  //   return this.requestService.postBasic(Api.Admin.CustomerAccountValidation, this._options, account, BaseResponse);
  // }
  customerremittance(id: string): Observable<UserRemittanceResult> {
    return this.requestService.getBasic(Api.Admin.CustomerRemittance(id), this._options, UserRemittanceResult);
  }
  customervalidatemobile(modify: UserValidateMobile): Observable<UserValidateMobileResult> {
    return this.requestService.postBasic(Api.Admin.CustomerValidateMobile, this._options, modify, UserValidateMobileResult);
  }

  customerverifymobile(modify: UserVerifyMobile): Observable<UserValidateMobileResult> {
    return this.requestService.postBasic(Api.Admin.CustomerVerifyMobile, this._options, modify, UserValidateMobileResult);
  }

  customerblock(customer: Customer): Observable<UserValidateMobileResult> {
    return this.requestService.postBasic(Api.Admin.CustomerBlock, this._options, customer, UserValidateMobileResult);
  }

  customerfiledata(idx: number): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.CustomerFileData + '/' + idx + '/data', this._options, BaseResponse);
  }

  // transaction

  inbtransactioncomment(detail: InbTransactionDetail): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.TransactionComment, this._options, detail, BaseResponse);
  }

  inbtransaction(option: TransactionSearch): Observable<InbTransactionListResult> {
    return this.requestService.postBasic(Api.Admin.InbTransaction, this._options, option, InbTransactionListResult);
  }
  
  subInftransaction(option: TransactionSubInfSearch): Observable<TransactionSubInfListResult> {
    return this.requestService.postBasic(Api.Admin.TransactionSubInf, this._options, option, TransactionSubInfListResult);
  }
  
  servicesubInftransactionNew(subInf: SubInfTransaction): Observable<TransactionSubInfResult> {
    return this.requestService.postBasic(Api.Admin.TransactionSubInfNew, this._options, subInf, TransactionSubInfResult);
  }

  servicesubInftransactionUpdate(subInf: SubInfTransaction): Observable<TransactionSubInfResult> {
    return this.requestService.postBasic(Api.Admin.TransactionSubInfUpdate, this._options, subInf, TransactionSubInfResult);
  }

  servicesubInftransactionDelete(value: string): Observable<TransactionSubInfResult> {
    return this.requestService.getBasic(Api.Admin.TransactionSubInfDelete(value), this._options, TransactionSubInfResult);
  }


  transactioncheckremittance(id: Object): Observable<TransactionCheckRemittanceResult> {
    return this.requestService.postBasic(Api.Admin.AMLCheckRemittance, this._options, id, TransactionCheckRemittanceResult);
  }

  transaction(option: TransactionSearch): Observable<TransactionListResult> {
    return this.requestService.postBasic(Api.Admin.Transaction, this._options, option, TransactionListResult);
  }

  transactionget(id: string): Observable<TransactionGetResult> {
    return this.requestService.getBasic(Api.Admin.TransactionGet + '/' + id, this._options, TransactionGetResult);
  };

  transactiondetail(id: string): Observable<TransactionDetailResult> {
    return this.requestService.getBasic(Api.Admin.TransactionDetail + '/' + id, this._options, TransactionDetailResult);
  };

  inbtransactiondetail(id: string): Observable<InbTransactionDetailResult> {
    return this.requestService.getBasic(Api.Admin.InbTransactionDetail + '/' + id, this._options, InbTransactionDetailResult);
  };

  transactioncancel(cancel: TransactionCancel): Observable<TransactionCancelResult> {
    return this.requestService.postBasic(Api.Admin.TransactionCancel, this._options, cancel, TransactionCancelResult);
  }

  transactionpending(pending: TransactionPending): Observable<TransactionPendingResult> {
    return this.requestService.postBasic(Api.Admin.TransactionPending, this._options, pending, TransactionPendingResult);
  }

  inbtransactioncancelled(pending: TransactionCancel): Observable<TransactionCancelResult> {
    return this.requestService.postBasic(Api.Admin.InbTransactionCancelled, this._options, pending, TransactionCancelResult);
  }

  transactionapprove(approve: TransactionApprove): Observable<TransactionApproveResult> {
    return this.requestService.postBasic(Api.Admin.TransactionApprove, this._options, approve, TransactionApproveResult);
  }

  inbtransactionapprove(approve: TransactionApprove): Observable<TransactionApproveResult> {
    return this.requestService.postBasic(Api.Admin.InbTransactionApprove, this._options, approve, TransactionApproveResult);
  }

  inbtransactionreadytopay(approve: TransactionApprove): Observable<TransactionApproveResult> {
    return this.requestService.postBasic(Api.Admin.InbTransactionReadyToPay, this._options, approve, TransactionApproveResult);
  }

  transactionforcedapprove(approve: TransactionApprove): Observable<TransactionApproveResult> {
    return this.requestService.postBasic(Api.Admin.TransactionForcedApprove, this._options, approve, TransactionApproveResult);
  }

  transactionsender(option: UserSearch): Observable<CustomerListResult> {
    return this.requestService.postBasic(Api.Admin.TransactionSender, this._options, option, CustomerListResult);
  }

  transactionreceiver(id: string): Observable<ReceiverListResult> {
    return this.requestService.getBasic(Api.Admin.TransactionReceiver(id), this._options, ReceiverListResult);
  }

  transactionreceiverbymode(id: string, mode: ReceiverListQueryMode): Observable<ReceiverListResult> {
    return this.requestService.getBasic(Api.Admin.TransactionReceiver(id) + (mode ? '?querymode=' + mode.toString() : ''), this._options, ReceiverListResult);
  }

  transactioncountry(): Observable<PayoutCountryListResult> {
    return this.requestService.getCacheMode(Api.Admin.TransactionCountry, this._options, PayoutCountryListResult, 10);
  }

  transactionbankbytype(partner: string, payout_type: string): Observable<PayoutBankListResult> {
    return this.requestService.getCacheMode(Api.Admin.TransactionPayoutBankByType(partner, payout_type), this._options, PayoutBankListResult);
  }

  transactionbankbytypewithcachemode(partner: string, payout_type: string, cache_time: number): Observable<PayoutBankListResult> {
    return this.requestService.getCacheMode(Api.Admin.TransactionPayoutBankByType(partner, payout_type), this._options, PayoutBankListResult, cache_time);
  }

  transactionbranchbytype(partner: string, type: string): Observable<PayoutBranchListResult> {
    return this.requestService.getCacheMode(Api.Admin.TransactionPayoutBranchByType(partner, type), this._options, PayoutBranchListResult);
  }

  transactionbranchbytypewithcachemode(partner: string, type: string, cache_time: number): Observable<PayoutBranchListResult> {
    return this.requestService.getCacheMode(Api.Admin.TransactionPayoutBranchByType(partner, type), this._options, PayoutBranchListResult, cache_time);
  }

  getpayoutbranches(partner: string, bank_code: string, payout_type: string): Observable<PayoutBranchListResult> {
    const reqBody = new Object();
    reqBody['partner_id'] = partner;
    reqBody['bank_code'] = bank_code;
    reqBody['payout_type'] = payout_type;
    return this.requestService.postBasic(Api.Admin.GetPayoutBranches, this._options, reqBody, PayoutBranchListResult);
  }

  transactionrate(payment: ReqPaymentRate): Observable<TransactionRateResult> {
    return this.requestService.postBasic(Api.Admin.TransactionRate, this._options, payment, TransactionRateResult);
  }

  transactionsave(transaction: Transaction): Observable<TransactionSaveResult> {
    return this.requestService.postBasic(Api.Admin.TransactionSave, this._options, transaction, TransactionSaveResult);
  }

  transactionvalid(transaction: Transaction): Observable<TxnValidResult> {
    return this.requestService.postBasic(Api.Admin.TransactionValid, this._options, transaction, TxnValidResult);
  }

  transactionupdate(detail: TransactionDetail): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.TransactionUpdate, this._options, detail, BaseResponse);
  }

  transactionedit(detail: Transaction): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.TransactionEdit, this._options, detail, BaseResponse);
  }

  branchdetail(partner_id, branch_code: string): Observable<BranchDetailResult> {
    return this.requestService.getBasic(Api.Admin.BranchDetail(partner_id, branch_code), this._options, BranchDetailResult);
  }

  getbranchlist(querymode?: PayoutBranchQueryMode): Observable<BranchListResult> {
    return this.requestService.getCacheMode(Api.Admin.BranchList + (querymode !== null ? '?query=' + PayoutBranchQueryModeUtil.toQueryParam(querymode) : ''), this._options, BranchListResult, 10);
  }

  getagentlist(): Observable<AgentListResult> {
    return this.requestService.getCacheMode(Api.Admin.AgentList, this._options, AgentListResult);
  }

  branchnew(branch: PayoutBranch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.BranchNew, this._options, branch, BaseResponse);
  }

  branchupdate(branch: PayoutBranch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.BranchUpdate, this._options, branch, BaseResponse);
  }

  agentnew(agent: Agent): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.AgentNew, this._options, agent, BaseResponse);
  }

  agentupdate(agent: Agent): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.AgentUpdate, this._options, agent, BaseResponse);
  }

  agentdetail(id: string): Observable<AgentDetailResult> {
    return this.requestService.getBasic(Api.Admin.AgentDetail(id), this._options, BaseResponse);
  }

  amlcheck(user: User): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.AMLCheck, this._options, user, BaseResponse);
  }

  fiureport(option: FIUReportSearch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.FIUReport, this._options, option, BaseResponse);
  }

  fiureportdetail(item: FIUReportListItem): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.FIUReportDetail, this._options, item, BaseResponse);
  }

  fiublock(item: FIUReportDetail): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.FIUReportBlock, this._options, item, BaseResponse);
  }

  fiureportexportexcel(option: FIUReportSearch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.FIUReportExportExcel, this._options, option, BaseResponse);
  }

  deposithistory(option: DepositHistoryListSearch): Observable<DepositHistoryResult> {
    return this.requestService.postBasic(Api.Admin.DepositHistyoryList, this._options, option, DepositHistoryResult);
  }

  getUserTransactionList(id: string, year: number, type: string): Observable<UserTransactionListResult> {
    return this.requestService.getBasic(Api.Admin.UserTransactionList + '/' + id + '/' + year + '/' + type, this._options, UserTransactionList);
  }


  setKycStatus(customer: User): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.LianLian.Admin.KYCSet, this._options, customer, BaseResponse);
  }

  setTxnStatus(txn: TransactionDetail): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.LianLian.Admin.TXNSet, this._options, txn, BaseResponse);
  }

  // llphome(): Observable<LLPHomeResult> {
  //   return this.requestService.get(Api.LianLian.Admin.Home, this._options, LLPHomeResult);
  // }

  refundlist(param: RefundSearch): Observable<RefundListResult> {
    return this.requestService.postBasic(Api.LianLian.Admin.RefundList, this._options, param, RefundListResult);
  }

  refunddetail(id: string): Observable<RefundDetailResult> {
    return this.requestService.getBasic(Api.LianLian.Admin.RefundDetail(id), this._options, RefundDetailResult);
  }

  updateRefundStatus(param: Refund): Observable<RefundDetailResult> {
    return this.requestService.postBasic(Api.LianLian.Admin.updateRefundStatus, this._options, param, RefundDetailResult);
  }

  addRefund(param: Refund): Observable<RefundDetailResult> {
    return this.requestService.postBasic(Api.LianLian.Admin.insertRefund, this._options, param, RefundDetailResult);
  }

  getAddressStateList(): Observable<BaseResponse> {
    return this.requestService.getCacheMode(Api.Admin.KYCAddressState, this._options, BaseResponse, 10);
  }

  searchAddressByZipcode(zipcode: string): Observable<AddressSearchResult> {
    return this.requestService.getBasic(Api.Admin.KYCSearchAddressByZipCode(zipcode), this._options, AddressSearchResult);
  }

  getDepositAccList(): Observable<BaseResponse> {
    return this.requestService.getCacheMode(Api.Admin.DepositAccountList, this._options, BaseResponse, 10);
  }

  getDepositBranches(): Observable<BankBranchListResult> {
    return this.requestService.getBasic(Api.Admin.DepositBranches.getDepositBranches, this._options, BankBranchListResult);
  }

  addDepositBranch(branchAddForm: DepositBranchAddForm): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.DepositBranches.addDepositBranch, this._options, branchAddForm, BaseResponse);
  }

  updateDepositBranch(branchList: DepositBranchList): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.DepositBranches.updateDepositBranch, this._options, branchList, BaseResponse);
  }

  deleteDepositBranch(idx: number): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.DepositBranches.deleteDepositBranch(idx), this._options, null, BaseResponse);
  }

  userNationalityList(): Observable<PayoutCountryListResult> {
    return this.requestService.getCacheMode(Api.Admin.UserNationalityList, this._options, PayoutCountryListResult, 2);
  }

  getKycCount(): Observable<UserKycCountResponse> {
    return this.requestService.getBasic(Api.Admin.CustomerKycCount, this._options, UserKycCountResponse);
  }

  server_version(): Observable<BaseResponse> {
    return this.requestService.getCacheMode(Api.Admin.Version, this._options, BaseResponse, 10);
  }

  getCustomerSimilarList(id: string): Observable<CustomerListResult> {
    return this.requestService.getBasic(Api.Admin.CustomerSimilarList + '/' + id, this._options, CustomerListResult);
  }

  customerMerge(param: MergeCustomer): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.CustomerMerge, this._options, param, BaseResponse);
  }

  resetFailedCount(id: string): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.ResetFailedCount + '/' + id, this._options, BaseResponse);
  }

  getCustomerCoi(id: string, coi_type: string): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.CustomerCoi + '/' + id + '/' + coi_type, this._options, BaseResponse);
  }

  accountValidation(transaction: PayoutAccValidate): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.AccountValidation, this._options, transaction, BaseResponse);
  }

  getDepositSlip(slipInfo: DepositSlipInfo): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.GetDepositSlipInfo, this._options, slipInfo, BaseResponse);
  }

  /*notice*/
  notice(option: NoticeSearch): Observable<NoticeListResult> {
    return this.requestService.postBasic(Api.Admin.NoticeList, this._options, option, NoticeListResult);
  }

  noticeDetail(idx: string): Observable<NoticeDetailResult> {
    return this.requestService.getBasic(Api.Admin.Notice + '/' + idx + '/detail', this._options, NoticeListResult);
  }

  noticeInsert(notice: Notice): Observable<NoticeModifyResult> {
    return this.requestService.postBasic(Api.Admin.NoticeInsert, this._options, notice, NoticeModifyResult);
  }

  noticeUpdate(notice: Notice): Observable<NoticeModifyResult> {
    return this.requestService.postBasic(Api.Admin.NoticeUpdate, this._options, notice, NoticeModifyResult);
  }

  noticeDelete(idx: string): Observable<NoticeModifyResult> {
    return this.requestService.postBasic(Api.Admin.NoticeDelete, this._options, idx, NoticeModifyResult);
  }

  noticeAlwaysShowOptionUpdate(list: Object): Observable<NoticeModifyResult> {
    return this.requestService.postBasic(Api.Admin.NoticeAlwaysOptionUpdate, this._options, list, NoticeModifyResult);
  }

  push(option: PushSearch): Observable<PushListResult> {
    return this.requestService.postBasic(Api.Admin.PushList, this._options, option, PushListResult);
  }

  pushDetail(idx: string): Observable<PushDetailResult> {
    return this.requestService.getBasic(Api.Admin.Push + '/' + idx + '/detail', this._options, PushListResult);
  }

  pushInsert(push: Push): Observable<PushModifyResult> {
    return this.requestService.postBasic(Api.Admin.PushInsert, this._options, push, PushModifyResult);
  }

  pushUpdate(push: Push): Observable<PushModifyResult> {
    return this.requestService.postBasic(Api.Admin.PushUpdate, this._options, push, PushModifyResult);
  }

  pushDelete(idx: string): Observable<NoticeModifyResult> {
    return this.requestService.postBasic(Api.Admin.PushDelete, this._options, idx, NoticeModifyResult);
  }

  saveDepositAcc(txnInfo: TxnDepositInfo): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.DepositAccountSave, this._options, txnInfo, BaseResponse);
  }

  /*mobile version*/
  mobileVersion(option: VersionSearch): Observable<VersionListResult> {
    return this.requestService.postBasic(Api.Admin.MobileVersionList, this._options, option, VersionListResult);
  }

  mobileVersionDetail(os_info: string, version: string): Observable<VersionDetailResult> {
    return this.requestService.getBasic(Api.Admin.MobileVersion + '/' + os_info + '/' + version + '/detail', this._options, VersionListResult);
  }

  mobileVersionInsert(version: Version): Observable<VersionModifyResult> {
    return this.requestService.postBasic(Api.Admin.MobileVersionInsert, this._options, version, VersionModifyResult);
  }

  mobileVersionUpdate(version: Version): Observable<VersionModifyResult> {
    return this.requestService.postBasic(Api.Admin.MobileVersionUpdate, this._options, version, VersionModifyResult);
  }

  mobileVersionDelete(version: Version): Observable<VersionModifyResult> {
    return this.requestService.postBasic(Api.Admin.MobileVersionDelete, this._options, version, VersionModifyResult);
  }
  /* login history */
  getloginhistory(options: LoginHistorySearch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.GetLoginHistory, this._options, options, BaseResponse);
  }

  /*bank deposit history*/
  getbankdeposithistory(options: BankDepositSearch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.GetBankDepositHistory, this._options, options, BaseResponse);
  }

  updatebankdeposithistory(): Observable<BaseResponse> {
    return this.requestService.getNoWait(Api.Admin.UpdateBankDepositHistory,  this._options, BaseResponse);
  }

  mapbankdepositwithtxn(options: BankDepositListMappedTxn): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.MapBankDepositHistory, this._options, options, BaseResponse);
  }

  mapbankdepositwithtxnlist(options: BankDepositListMappedTxnList): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.MapBankDepositListHistory, this._options, options, BaseResponse);
  }

  updatecustomerextname(options: UpdateCustomerExtName): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.UpdateCustomerExtName, this._options, options, BaseResponse);
  }

  getbankaccountlist(): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.GetBankDepositAccounts, this._options, BaseResponse);
  }

  updatebankaccountlist(options: Bankaccountupdatelist): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.UpdateBankDepositAccounts, this._options, options, BaseResponse);
  }

  refunddepositlist(reqBody: ReqRefundDepositList): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.RefundDepositList, this._options, reqBody, BaseResponse);
  }

  /* expired customers */
  getexpiredcustomerlist(search: ExpiredSearch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.ExpiredCustomerList, this._options, search, BaseResponse);
  }

  getServiceListByPartner(partner_id: string): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.GetServiceListByPartner(partner_id), this._options, BaseResponse);
  }

  saveDepositMemo(body: BankDepositInfo): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.SaveDepositMemo, this._options, body, BaseResponse);
  }

  disabledepositlist(reqBody: ReqDisableDipositList): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.DisableDepositList, this._options, reqBody, BaseResponse);
  }

  uploadsanctionfile(reqBody: UploadFile): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.UploadSanctionFile, this._options, reqBody, BaseResponse);
  }

  mypage(login: Admin): Observable<LoginResult> {
    return this.requestService.postBasic(Api.Admin.MyPage, this._options, login, LoginResult);
  }

  mypageupdate(agent: Admin): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.MyPageUpdate, this._options, agent, BaseResponse);
  }

  passwordupdate(password: PasswordChange): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.PasswordUpdate, this._options, password, BaseResponse);
  }

  getdepositpartners(): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.GetDepositPartners, this._options, BaseResponse);
  }

  gettxninfolist(type: string): Observable<TxnSubInfoResponse> {
    return this.requestService.getCacheMode(Api.Admin.GetTxnInfoList(type), this._options, TxnSubInfoResponse, 10);
  }

  gettxninfofulllist(): Observable<BaseResponse> {
    return this.requestService.getCacheMode(Api.Admin.GetTxnInfoFullList, this._options, BaseResponse, 10);
  }

  getsanctioninfofiles(): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.GetSancFileInfo, this._options, BaseResponse);
  }

  getmanageaccounts(search: ManageAccountSearch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.GetManageAccount, this._options, search, BaseResponse);
  }

  getmanageaccountdetail(item: ManageAccount): Observable<BaseResponse> {
    const reqBody = {};
    reqBody['customer_idx'] = item.customer_idx;
    reqBody['coi_acc_idx'] = item.coi_acc_idx;
    reqBody['receiver_idx'] = item.rc_idx;
    reqBody['receiver_account_idx'] = item.rc_acc_idx;
    return this.requestService.postBasic(Api.Admin.GetManageAccountDetail, this._options, reqBody, BaseResponse);
  }

  updateTxnFeeWithRestoreToWFD(object: any): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.SaveTxnFee, this._options, object, BaseResponse);
  }

  getSearchResources(): Observable<BaseResponse> {
    return this.requestService.getCacheMode(Api.Admin.SearchResources, this._options, BaseResponse, 5);
  }

  getexternalpartners(): Observable<ADMPartnersResult> {
    return this.requestService.getBasic(Api.Admin.GetExternalPartners, this._options, ADMPartnersResult);
  }

  savenewreceiveraccount(account: ManageAccountForSave): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.SaveNewReceiverAccount, this._options, account, BaseResponse);
  }

  deletereceiveraccount(item: ManageAccountForSave): Observable<BaseResponse> {
    const reqBody = {};
    reqBody['customer_idx'] = item.customer_idx;
    reqBody['coi_acc_idx'] = item.account.idx;
    reqBody['receiver_idx'] = item.receiver.idx;
    reqBody['receiver_account_idx'] = item.receiver.account[0].idx;
    return this.requestService.postBasic(Api.Admin.DeleteReceiverAccount, this._options, reqBody, BaseResponse);
  }

  receiverlist(search: UserSearch): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.GetReceiverList, this._options, search, BaseResponse);
  }

  deleteReceiver(index: string): Observable<BaseResponse> {
    return this.requestService.getBasic(Api.Admin.DeleteReceiver(index), this._options, BaseResponse);
  }

  saveBeneficiaryList(list: ReqReceiverList): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.SaveBeneficiaryList, this._options, list, BaseResponse);
  }

  insertmailinglist(data: MailSubscribe): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.InsertDailyMailingList, this._options, data, BaseResponse);
   }

  getdailymailinglists(): Observable<BaseResponse> {
     return this.requestService.getBasic(Api.Admin.DailyMailingLists, this._options, BaseResponse);
    }

  updatedailymailinglists(data: UpdateMailingInfo): Observable<BaseResponse> {
    return this.requestService.postBasic(Api.Admin.DailyMailingLists, this._options, data, BaseResponse);
  }

  deletedailymailinglistbymailaddress(data: string): Observable<BaseResponse> {
    const mailAddress = {mail_address: data};
    return this.requestService.postBasic(Api.Admin.DeleteDailyMailingLists, this._options, mailAddress, BaseResponse);
  }

  payoutpartnergrouplist(): Observable<PartnerGroupResult> {
    return this.requestService.getBasic(Api.Admin.PayoutPartnerGroupList, this._options, PartnerGroupResult);
  }

  getCustomerSnsInfo(agentId: string): Observable<CustomerSnsInfoResult>{
    return this.requestService.getBasic(Api.Admin.getCustomerSnsInfo(agentId), this._options, CustomerSnsInfoResult);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/admin/admin.service.ts